module.exports = __webpack_public_path__ + "img/user.c87dd0ec.svg";